import React from 'react';
import propTypes from 'prop-types';
import styles from './StatusBadge.module.scss';

const StatusBadge = ({ type }) => {
	return (
		<div className={`${styles.badgeContainer} ${styles[type.name]}`}>
			<p>{type.displayText}</p>
		</div>
	);
};

StatusBadge.propTypes = {
	type: propTypes.object.isRequired,
};

export default StatusBadge;
